<template>
  <div class="container">
    <div class="row">
      <div v-for="(stat, key) in value" :class="{ 'border-left': key !== 0 }" class="bg-light col p-4 text-center" :key="key">
        <h5 class="h3">
          {{ stat.stat }}
        </h5>
        <div v-tooltip="{ placement: 'bottom', text: stat.tooltip || '' }">{{ stat.text }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BaseStats',

  props: {
    value: Array
  }
}
</script>
